"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeType = void 0;
var ExchangeType;
(function (ExchangeType) {
    ExchangeType["ITEM"] = "ITEM";
    ExchangeType["PRICE"] = "PRICE";
})(ExchangeType || (exports.ExchangeType = ExchangeType = {}));
//# sourceMappingURL=asset-component-history.js.map